const isProd = process.env.NODE_ENV === 'production';

const style = {
  info: [
    'padding: 0.25rem;',
    'margin: 0 0.5rem 0 0;',
    'background: #00B6C7;',
    'color: white;',
  ].join(''),
  danger: [
    'padding: 0.25rem;',
    'margin: 0 0.5rem 0 0;',
    'background: #F24949;',
    'color: white;',
  ].join(''),
  message: ['color: #828294;'].join(''),
};

const Logger = {
  debug: (data, message) => {
    if (isProd) {
      return;
    }
    console.info(
      '%c%s%c%s',
      style.info,
      'Logger',
      style.message,
      message || 'Debug'
    );
    console.info(data);
  },
  error: (error, message) => {
    if (isProd) {
      window.SentryHelper?.captureException(error, message);
      return;
    }
    console.error(
      '%c%s%c%s',
      style.danger,
      'Logger',
      style.message,
      message || 'Error'
    );
    console.error(error);
  },
};

export default Logger;
